export const useStyles = () => {
    return {
        number: {
            fontSize: '45px',
            textAlign: 'center',
            color: 'c_grey.main'
        },
        text: {
            fontSize: '13px',
            textAlign: 'center',
            fontWeight: '700'
        },
        display: {
            display: 'flex',
            flexDirection: 'column',
        }
    }
}